jQuery(document).ready(function(jQuery) {
  
  jQuery(".load-more-cta").click(function() {
    load_posts(this, true);
  });

  //For list type filters
  jQuery(".search-items li").click(function() {
    var $button = jQuery(this);
    jQuery('.search-items li.active').removeClass('active');
    $button.addClass("active");
    load_posts(this, false);
  });

  //for dropdown type filters
  jQuery(".select-wrapper #topics").change(function() {
    var $button = jQuery(this);
    load_filtered_posts(1);
  });

  jQuery(".select-wrapper #post_type").change(function() {
    var $button = jQuery(this);
    var $poast_type = jQuery('.select-wrapper #post_type option:selected').attr('term-slug');
    var $post_container = jQuery('.tps-post-grid-cards .grid-container .resource-post-container-wrapper');
    $post_container.attr('data-post-type',$poast_type);
    load_filtered_posts(1);
  });

  jQuery('.search .date-search #date-select').change(function() {
    var $trg_elem = jQuery(this),
      elem = $trg_elem.closest('.search').find('.search-items .active')[0];
    load_posts(elem, false);
  });

  //For contern format filters
  jQuery('.select-wrapper #content-format').change(function() {
    load_filtered_posts(1);
  });

  //Resource Search Bar
  jQuery("#resource-search").keypress(function(e) {
    if(e.which == 13) {
      load_filtered_posts(1);
    }
  });

  //Resource Search Button
  jQuery("#search-cta").click(function() {
    load_filtered_posts(1);
  });

  //For pagination clicks
  jQuery("body").on("click", '.tps-post-grid-cards .page-numbers li a', function(e) {
    e.preventDefault();
    var page_number_elm = jQuery(this).attr('href');
    var page_number = page_number_elm.split('/page/')[1];
    load_filtered_posts(page_number);
  });

  // For Events Filter

  jQuery('.search .date-search #date-select').change(function() {
    var $trg_elem = jQuery(this),
      elem = $trg_elem.closest('.search').find('.search-items .active')[0];
    load_event_posts(elem, false);
  });

  jQuery('.search-container .cpg-filter #event-type').change(function() {
    var elem = jQuery(this).val();
    load_event_posts(elem, false);
  });

  jQuery('.search-container .cpg-filter #event-location').change(function() {
    var elem = jQuery(this).val();
    load_event_posts(elem, false);
  });

  jQuery('.search-container .cpg-filter #event-date').change(function() {
    var elem = jQuery(this).val();
    load_event_posts(elem, false);
  });

  jQuery("#event-search").keypress(function(e) {
    if(e.which == 13) {
      var elem = jQuery(this).val();
      load_event_posts(elem, false);
    }
  });

  function load_posts($elem, load_more) {

    var $trg_elem = jQuery($elem), terms = false;
    var offset = 0, limit = 8;
    var settings;

    if(!load_more) {
      var $button = jQuery('.tps-post-grid-cards.category-post-grid').find('.load-more-cta'); 
      terms = $trg_elem.attr('term-slug');
      if($button.length) {
        $button.attr('data-offset', 0);
        $button.attr("data-term", terms);
      }
      settings = jQuery('.tps-post-grid-cards.category-post-grid').data('settings');
    } else {
      var $button = $trg_elem;
      terms = $button.attr('data-term');
      settings = $trg_elem.closest('.tps-post-grid-cards.category-post-grid').data('settings');
    }

    if($button.length) {
      offset = $button.attr('data-offset');    
      limit = $button.attr('data-limit');
    }

    terms = (terms == 'all') ? false : terms;
    
    
    var $block = jQuery('.tps-post-grid-cards').find('.grid-container .tps-post-grid-cards-items.category-post-grid');
    var taxonomy = $block.attr('data-terms');
    var $search_wrapper = jQuery('.search.grid-container');
    var date_filter = $search_wrapper.find('#date-select').val();

    var post_type = $block.attr('data-post-type');
    var grid_display = $block.attr('data-grid-display');
    var post_data = {
      'action':'load_more_posts',
      'post_type' : post_type,
      'taxonomy' : JSON.parse(taxonomy),
      'offset' : offset,
      'limit' : limit,
      'grid_display' : grid_display,
      'date_filter' : date_filter
    };

    if(terms) {
      post_data.terms = terms;
    }

    post_data.settings = settings;

    jQuery.post({
      url: '/wp-admin/admin-ajax.php',
      data: post_data,
      success:function(data) {

        response = JSON.parse(data);

        if(response.post_count > 0) {

          if(load_more) {
            $block.append(response.content);            
          } else {
            $block.html(response.content);
          }

          var dataOffset = parseInt($button.attr('data-offset'));
          var dataLimit = parseInt($button.attr('data-limit'));
          totalOffset = dataOffset + dataLimit;
          $button.attr("data-offset", totalOffset);

          if(response.post_count < dataLimit) {
            $button.hide();
          } else {
            $button.show();
          }

        } else {
          if(load_more) {
            $block.append('<p class="mb-40">No more results</p>');
          } else {
            $block.html('<p class="mb-40">No results</p>');
          }
          $button.hide();
        }
      },
      error: function(errorThrown){
          window.alert(errorThrown);
          console.log(errorThrown);
      }
    });
  }

  function load_filtered_posts(page = 1) {
    var terms = false,
      search_keyword = jQuery('.search-container #resource-search').val(),
      terms = jQuery('.select-wrapper #topics option:selected').attr('term-slug'),
      settings = jQuery('.tps-post-grid-cards.category-post-grid').data('settings');

    terms = (terms == 'all') ? false : terms;

    var $block = jQuery('.tps-post-grid-cards').find('.grid-container .resource-post-container-wrapper'),
      taxonomy = $block.attr('data-terms'),
      $search_wrapper = jQuery('.search.grid-container'),
      date_filter = $search_wrapper.find('#date-select').val(),
      post_type = $block.attr('data-post-type'),
      grid_display = $block.attr('data-grid-display');

    var post_data = {
      'action': 'load_filtered_posts',
      'post_type': post_type,
      'taxonomy': JSON.parse(taxonomy),
      'page_number': page,
      'search_keyword': search_keyword
    };

    if (terms) {
      post_data.terms = terms;
    }
    post_data.settings = settings;

    jQuery.post({
      url: '/wp-admin/admin-ajax.php',
      data: post_data,
      success: function(data) {
        response = JSON.parse(data);
        if (response.post_count > 0) {
          $block.html(response.content);
        } else {
          $block.html('<p class="mb-40">No results</p>');
        }
      },
      error: function(errorThrown) {
        window.alert(errorThrown);
        console.log(errorThrown);
      }
    });
  }

  function load_event_posts($elem, load_event_posts, page = 1) {

    //var terms = false;
    //terms = jQuery('.select-wrapper #topics option:selected').attr('term-slug');
    var settings;
    var event_type = jQuery('.search-container #event-type').val();
    var $search_wrapper = jQuery('.search.grid-container');
    var event_location = jQuery('.search-container #event-location').val();
    var event_date = jQuery('.search-container #event-date').val();
    var event_search = jQuery('.search-container #event-search').val();
    settings = jQuery('.tps-post-grid-cards.category-post-grid').data('settings');

    //terms = (terms == 'all') ? false : terms;
    console.log(event_type,event_location,event_date, event_search);
    
    var $block = jQuery('.tps-post-grid-cards').find('.grid-container .event-post-container-wrapper');
    
    var $search_wrapper = jQuery('.search.grid-container');
    var date_filter = $search_wrapper.find('#date-select').val();
    var post_type = $block.attr('data-post-type');
    var grid_display = $block.attr('data-grid-display');
    var post_data = {
      'action':'load_event_posts',
      'post_type' : post_type,
      'page_number' : page,
      'date_filter' : date_filter,
      'event_type' : event_type,
      'event_location' : event_location,
      'event_date' : event_date,
      'event_search' : event_search
    };

    post_data.settings = settings;

    jQuery.post({
      url: '/wp-admin/admin-ajax.php',
      data: post_data,
      success:function(data) {

        response = JSON.parse(data);

        if(response.post_count > 0) {

          if(load_event_posts) {
            $block.append(response.content);

            var newAccordionItems = $block.find('.accordion-item:last');
            var newAccordionItemParent = jQuery('.grid-container .event-post-container-wrapper .accordion');
            if (newAccordionItemParent.length > 0) {
              var accordion = new Foundation.Accordion(newAccordionItemParent);
              accordion.up();
            }

          } else {
            $block.html(response.content);
            var accordionItems = $block.find('.accordion-item');
            var accordionItemParent = jQuery('.grid-container .event-post-container-wrapper .accordion');
            if (accordionItemParent.length > 0) {
              var accordion = new Foundation.Accordion(accordionItemParent);
              accordion.up();
            }

          }

        } else {
          if(load_event_posts) {
            $block.append('<p class="no-result">No more results</p>');
          } else {
            $block.html('<p class="no-result">No results</p>');
          }
        }
      },
      error: function(errorThrown){
          window.alert(errorThrown);
          console.log(errorThrown);
      }
    });
  }

});